export const compactGbp = (value: string | number | null) => {
  if (value === null) return null;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return null;
  if (Math.abs(amount) >= 1_000_000) return `£${(amount / 1_000_000).toFixed(1)}m`;
  if (Math.abs(amount) >= 1_000) return `£${Math.round(amount / 1_000)}k`;
  return `£${Math.round(amount)}`;
};

export const actionLabel = (daysToAction: number | null) => {
  if (daysToAction === null) return "No action date";
  if (daysToAction < 0) return `${-daysToAction}d overdue`;
  if (daysToAction === 0) return "Notice due today";
  return `${daysToAction}d to notice`;
};
